import createModelInstance from 'utils/createModelInstance';
import imageFallback from 'assets/images/image-not-available.png';

/**
 * Model of the products from Sugar API
 * The products have different categories which are:
 * - Keepsake
 * - Urn
 * - Memorialisation
 * @param {Object} productObj Object with key/values to create the new product
 *                      the keys can be camel case, snake case or kebab case
 * @return {Object} an Product object
 */
const Product = (productObj) => {
    let newProduct = {
        pivot: null,
        aclTeamSetId: null,
        assignedUserId: null,
        baseRate: '',
        category: '',
        categoryId: '',
        costPrice: '',
        costUsdollar: '',
        createdBy: '',
        cstm: null,
        currencyId: '',
        dateAvailable: null,
        dateCostPrice: null,
        dateEntered: '',
        dateModified: '',
        deleted: null,
        description: null,
        discountPrice: '',
        discountUsdollar: '',
        id: '',
        listPrice: null,
        listUsdollar: null,
        mftPartNum: '',
        name: '',
        packageProduct: null,
        pricingFactor: null,
        pricingFormula: null,
        productImages: [],
        qtyInStock: null,
        status: null,
        typeId: null,
        weight: null,
        packageId: null,
        baseId: null,
        hideInPortalModal: null
    };

    // Crates the Product object
    newProduct = createModelInstance(newProduct, productObj);

    return {
        ...newProduct,
        /**
         * Gets the product's category label
         * @return {string}
         */
        getCategory() {
            if (this.category && this.category.name) {
                return this.category.name;
            }
            return '';
        },
        /**
         * Gets the product image
         * @param {number} index Index of the image to retrieve
         * @param {string} defaultImage the default image if the object doesn't have an image
         * @return {string} the string url of the image
         */
        getImage(index = 0, defaultImage = imageFallback) {
            if (
                index >= 0
                && this.productImages
                && this.productImages.length > 0
                && this.productImages.length > index
            ) {
                return this.productImages[index].image;
            }
            return defaultImage;
        },
        /**
         * Gets the list of image src for a carousel
         * @param {number} carouselLen the length of the carousel (number of images in the carousel)
         * @return {Array} returns an array of images src
         */
        getImagesForCarousel(carouselLen = 3) {
            // Only displays the one image as a preview
            if (!this.productImages || this.productImages.length <= 1) {
                return [];
            } else if (this.productImages.length >= carouselLen) {
                // Only returns the number of images of the carousel length
                return this.productImages.slice(0, carouselLen).map((img) => img.image);
            }
            // If the values are not exact or greater than the carousel length
            // then it adjusts the images with empty src
            const diff = carouselLen - this.productImages.length;
            const imgSrcArray = this.productImages.map((img) => img.image);
            // Add empty values to adjust the carousel view columns
            imgSrcArray.push(...[...Array(diff).keys()].map(() => ''));
            return imgSrcArray;
        },
        /**
         * Get the product price to display with 2 decimal numbers
         * @param {string} priceKey If the price has a different key, by default is the key discountPrice
         * @return {string} the number formatted as string with 2 decimals
         */
        getPrice(priceKey = '') {
            if (priceKey && Object.hasOwnProperty.call(this, priceKey)) {
                return this[priceKey];
            } else if (this.discountPrice) {
                return parseFloat(this.discountPrice).toFixed(2);
            }
            return 0;
        }
    };
};

export default Product;
